const initState = {
  isLoading: false,
  customerData: [],
  allCustomers: [],
  customerRestData: null,
  updatedCustomerData: null,
};
const customerReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_CUSTOMER":
      return {
        ...state,
        customerData: action.payload,
      };
    case "GET_ALL_CUSTOMERS_FOR_RESTAURANT":
      return {
        ...state,
        allCustomers: action.payload,
      };
    case "CUSTOMER_DETAILS":
      return {
        ...state,
        customerRestData: action.payload,
      };
    case "CUSTOMER_LOADER":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "SET_UPDATED_CUSTOMER_DATA":
       return {
        ...state,
        updatedCustomerData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default customerReducer;
